<div class="pop-bg">
</div>
<div class="pop-position" id="addUserModal">
  <div class="row col-md-12 p-0 grey header-popup-box">
    <span class="col-md-10 col-sm-10 p-0">
      <div class="heading-panel pl-10">
        <span class="text-sm text-ellipsis heading-txt flex ml-10">Client Instruction Information Modal
        </span>
      </div>
    </span>
    <!-- <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor" (click)="closeModal()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </span> -->
  </div>
  <div class="body">

    <h1>You have Client Instructions to Read, Please go to Client Instruction screen !</h1>

  </div>
  <div class="col-md-12 p-0" id="footerSection">
    <div class="row p-0">
      <!-- <button type="button" class="btn blue square-btn blue-hover btn-txt mt-5 mb-5 w-51"
        (click)="clearForm()">Cancel</button> -->
      <button type="submit" class="btn blue square-btn blue-hover btn-txt mr-10 mt-5 mb-5" data-toggle="modal"
        data-target=".skip-ac" (click)="closeModal()">Redirect</button>
    </div>
  </div>

</div>
